import { u as useFederationColorScheme } from "./colorScheme.js";
import { u as useFederationDebug } from "./debug.js";
import { c as createFederationFeatureFlags } from "./featureFlags.js";
import { u as useFederationFragmentsManager } from "./fragmentsManager.js";
import { u as useFederationInjector } from "./injector.js";
import { u as useFederationLocalizationRoot } from "./localization.js";
import { u as useFederationNetwork } from "./network.js";
import { u as useFederationRootHandlers } from "./rootHandlers.js";
import { u as useFederationRootStorages } from "./rootStorages.js";
import { u as useFragmentVersions } from "./versions.js";
function useFederationRoot({ processException, requester, i18next }) {
  const rootInjector = useFederationInjector();
  const { colorScheme, setColorScheme } = useFederationColorScheme();
  const featureFlags = createFederationFeatureFlags();
  const rootStorages = useFederationRootStorages();
  const versions = useFragmentVersions(requester);
  const debug = useFederationDebug(versions);
  const rootHandlers = useFederationRootHandlers();
  const networkService = useFederationNetwork({ versions, processException, i18next });
  const federationLocalizationRoot = useFederationLocalizationRoot({ i18next, networkService });
  const fragmentsManager = useFederationFragmentsManager({
    federationLocalizationRoot,
    networkService,
    versions,
    rootStorages,
    processException
  });
  debug.register();
  rootInjector.__internal.provide("rootHandlers", rootHandlers);
  rootInjector.provide("featureFlags", featureFlags.fragmentApi);
  rootInjector.provide("colorScheme", { colorScheme });
  return {
    addRootHandler: rootHandlers.addRootHandler,
    invokeHandler: rootHandlers.invokeHandler,
    invokeRootHandler: rootHandlers.invokeRootHandler,
    setFeatureFlags: featureFlags.setFeatureFlags,
    setFeatureFlag: featureFlags.setFeatureFlag,
    hasFeatureFlag: featureFlags.hasFeatureFlag,
    loadManifest: networkService.loadManifest,
    getManifest: networkService.getManifest,
    preload: networkService.preload,
    loadVersions: versions.loadVersions,
    setColorScheme,
    setVersions: versions.setVersions,
    setVersion: versions.setVersion,
    hasVersion: versions.hasVersion,
    setVersionResolver: versions.setVersionResolver,
    /**
     * @deprecated use loadVersions() instead
     */
    get versions() {
      console.warn(
        'Usage of "versions" property is deprecated. Use loadVersions() or setVersions() instead'
      );
      return versions;
    },
    createFragment,
    setRouterFabric
  };
  function setRouterFabric(newRouterFabric) {
    rootInjector.__internal.provide("routerFabric", newRouterFabric);
  }
  function createFragment({ name }) {
    return fragmentsManager.createFragment({
      name,
      injector: rootInjector.__internal.fork(),
      requester
    });
  }
}
export {
  useFederationRoot as u
};
//# sourceMappingURL=root.js.map
